import script from "./PlayAudioModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayAudioModal.vue?vue&type=script&setup=true&lang=js"

import "./PlayAudioModal.vue?vue&type=style&index=0&id=f9e959a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9e959a2"]])

export default __exports__